/* 11STIJLENBIER theme JS */

(function() {
  'use strict';

  /* 1. Sticky header */
  const header = document.getElementById('siteHeader');
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(() => {
        header.classList.toggle('scrolled', window.scrollY > 40);
        ticking = false;
      });
      ticking = true;
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* 2. Reveal-on-scroll */
  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    reveals.forEach(el => io.observe(el));
  } else {
    reveals.forEach(el => el.classList.add('in'));
  }

  /* 3. Bier-detail panel */
  const grid = document.getElementById('bierenGrid');
  const detail = document.getElementById('bierDetail');
  const dName = document.getElementById('detailName');
  const dEyebrow = document.getElementById('detailEyebrow');
  const dMeta = document.getElementById('detailMeta');
  const dDesc = document.getElementById('detailDesc');
  const dClose = document.getElementById('detailClose');

  /*if (grid) {
    grid.addEventListener('click', (e) => {
      const card = e.target.closest('.bier');
      if (!card || card.classList.contains('bier--locked')) return;

      const name = card.dataset.name;
      const style = card.dataset.style;
      const city = card.dataset.city;
      const lekkernij = card.dataset.lekkernij;
      const desc = card.dataset.desc;
      const status = card.dataset.status;

      dEyebrow.textContent = (status === 'soldout' ? 'Uitverkocht · ' : 'Beschikbaar · ') + lekkernij;
      dName.textContent = name;
      dMeta.innerHTML =
        '<span><strong>' + style + '</strong></span>' +
        '<span>Lekkernij: <strong>' + lekkernij + '</strong></span>' +
        '<span>Stad: <strong>' + city + '</strong></span>';
      dDesc.textContent = desc;

      detail.classList.add('is-open');
      setTimeout(() => detail.scrollIntoView({ behavior: 'smooth', block: 'center' }), 100);
    });
  
  if (dClose) {
    dClose.addEventListener('click', () => detail.classList.remove('is-open'));
  }}*/

  /* 4. Locatie-filters */
  const filterBar = document.getElementById('locationFilters');
  const list = document.getElementById('locationList');
  if (filterBar && list) {
    filterBar.addEventListener('click', (e) => {
      const btn = e.target.closest('.filter');
      if (!btn) return;
      filterBar.querySelectorAll('.filter').forEach(f => f.classList.remove('is-active'));
      btn.classList.add('is-active');

      const f = btn.dataset.filter;
      list.querySelectorAll('.location').forEach(loc => {
        const type = loc.dataset.locationType;
        const region = loc.dataset.region;
        let show = false;
        if (f === 'all') show = true;
        else if (f === 'friesland') show = region === 'friesland';
        else show = type === f;
        loc.classList.toggle('locations__hidden', !show);
      });
    });
  }

  /* 5. Smooth-scroll fallback */
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', (e) => {
      const id = a.getAttribute('href');
      if (id.length > 1) {
        const target = document.querySelector(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });

})();
